import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    filterDropdownContainer: {
        zIndex: 2,
        flex: 1
    },
    filterSection: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    searchContainer: {
        minWidth: 250,
        flex: 1
    }
});

export default stylesheet;
